import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import EmptyParentView from '@/views/EmptyParentView.vue'
import AdminOrgView from '@/views/admin/OrganizationView.vue'
import AdminUserView from '@/views/admin/UserView.vue'
import ProductView from '@/views/organization/ProductView.vue'
import OrganizationParentView from '@/views/organization/OrganizationParentView.vue'
import ProductConfigurationView from '@/views/organization/ProductConfigurationView.vue'
import LibraryView from '@/views/organization/LibraryView.vue'
import LibraryStepView from '@/views/organization/LibraryStepView.vue'
import SiteView from '@/views/organization/SiteView.vue'
import BopView from '@/views/organization/BopView.vue'
import BopProcessView from '@/views/organization/BopProcessView.vue'
import StepTypeView from '@/views/organization/StepTypeView.vue'
import IconView from '@/views/organization/IconView.vue'
import IssueLabelView from '@/views/organization/IssueLabelView.vue'
import ModuleView from '@/views/organization/ModuleView.vue'
import ToolView from '@/views/organization/ToolView.vue'
import EbomView from '@/views/organization/EbomView.vue'
import opentelemetry, { Span } from '@opentelemetry/api'
import OperatorHomeView from '@/views/organization/operator/OperatorHomeView.vue'
import OperatorProductConfigurationView from '@/views/organization/operator/OperatorProductConfigurationView.vue'
import OperatorModuleView from '@/views/organization/operator/OperatorModuleView.vue'
import ArticleView from '@/views/organization/ArticleView.vue'
import OperatorParentView from '@/views/organization/operator/OperatorParentView.vue'
import IssueView from '@/views/organization/IssueView.vue'
import ProductionBatchView from '@/views/organization/ProductionBatchView.vue'
import OrgUserView from '@/views/organization/UserView.vue'
import TestView from '@/views/organization/TestView.vue'
import OrgHomeView from '@/views/organization/OrgHomeView.vue'
import UploadView from '@/views/organization/UploadView.vue'

declare module 'vue-router' {
  interface RouteMeta {
    library?: boolean
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      name: 'admin-parent',
      path: '/admin/',
      component: EmptyParentView,
      children: [
        {
          name: 'admin-organizations',
          path: 'organizations',
          component: AdminOrgView,
        },
        {
          name: 'admin-users',
          path: 'users',
          component: AdminUserView,
        },
      ],
    },
    {
      name: 'organization-parent',
      path: '/organization/:organizationSlug/',
      component: OrganizationParentView,
      children: [
        {
          name: 'orgHome',
          path: '',
          component: OrgHomeView,
        },
        {
          name: 'test',
          path: 'test',
          component: TestView,
        },
        {
          name: 'articles',
          path: 'articles',
          component: ArticleView,
        },
        {
          name: 'production-batches',
          path: 'production-batches/:productionBatchId?',
          component: ProductionBatchView,
        },
        {
          name: 'issues',
          path: 'issues/:issueId?',
          component: IssueView,
        },
        {
          name: 'uploads',
          path: 'uploads',
          component: UploadView,
        },
        {
          name: 'sites',
          path: 'sites',
          component: SiteView,
        },
        {
          name: 'tools',
          path: 'tools',
          component: ToolView,
        },
        {
          name: 'stepTypes',
          path: 'step-types',
          component: StepTypeView,
        },
        {
          name: 'icons',
          path: 'icons',
          component: IconView,
        },
        {
          name: 'issueLabels',
          path: 'issue-labels',
          component: IssueLabelView,
        },
        {
          name: 'products',
          path: 'products',
          component: ProductView,
        },
        {
          name: 'productConfigurations',
          path: 'products/:productId/configurations',
          component: ProductConfigurationView,
        },
        {
          name: 'library',
          path: 'library',
          component: LibraryView,
          meta: { library: true },
        },
        {
          name: 'libraryStep',
          path: 'library/step/:stepId',
          component: LibraryStepView,
          meta: { library: true },
        },
        {
          name: 'bops',
          path: 'products/:productId/configurations/:productConfigId/sites/:siteId/bills-of-process',
          component: BopView,
        },
        {
          name: 'bopProcess',
          path: 'products/:productId/configurations/:productConfigId/sites/:siteId/bills-of-process/:bopId',
          component: BopProcessView,
        },
        {
          name: 'module',
          path: 'products/:productId/configurations/:productConfigId/sites/:siteId/bills-of-process/:bopId/module/:moduleId/:nodeId?',
          component: ModuleView,
        },
        {
          name: 'ebom',
          path: 'products/:productId/configurations/:productConfigId/sites/:siteId/bills-of-process/:bopId/ebom/:ebomId/:ebomPartId?',
          component: EbomView,
        },
        {
          name: 'users',
          path: 'users',
          component: OrgUserView,
        },
        {
          name: 'operatorParent',
          path: 'operator/',
          component: OperatorParentView,
          children: [
            {
              name: 'operatorHome',
              path: '',
              component: OperatorHomeView,
            },
            {
              name: 'operatorProductConfigurations',
              path: 'products/:productId/configurations',
              component: OperatorProductConfigurationView,
            },
            {
              name: 'operatorModule',
              path: 'products/:productId/configurations/:productConfigId/sites/:siteId/bills-of-process/:bopId/module/:moduleId/:stepId?',
              component: OperatorModuleView,
            },
          ],
        },
      ],
    },
  ],
})
let routerSpan: Span | undefined = undefined
router.beforeEach((to) => {
  const tracer = opentelemetry.trace.getTracer('vue-router', '1.0')
  routerSpan = tracer.startSpan(`route-${to.path}`)
})
router.afterEach(() => {
  if (routerSpan) {
    routerSpan.end()
  }
})

export default router
